import React from 'react';
import styled from 'styled-components';
import { TitleBlock } from './TitleBlock';

import dms from '../images/partners-logo/dms.png';
import grape from '../images/partners-logo/grape.png';
import hungry from '../images/partners-logo/hungry.png';
import possible from '../images/partners-logo/possible.png';
import vlad from '../images/vlad.png';

const Wrap = styled.section`
    display: flex;
    justify-content: center;
    margin-top: -200px;
    @media screen and (max-width: 800px) {
        margin-top: 0;
    }
`;
const Container = styled.div`
    padding: 70px 0;
    max-width: 1440px;
    margin: 0 auto;
    overflow: hidden;
    @media screen and (max-width: 800px) {
        padding: 50px 20px 20px;
    }
`;
const Title = styled.div`
    margin-bottom: 20px;
`;
const Description = styled.p`
    text-align: center;
    margin-bottom: 90px;
    text-align: center;
    font-size: 18px;
    max-width: 700px;
    font-weight: 400;
    a {
        color: inherit;
        border-bottom: 1px solid black;
        transition: 0.15s ease;
        &:hover {
            border-bottom: 1px solid transparent;
        }
    }
    @media screen and (max-width: 800px) {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 50px;
        padding: 0 20px;
        width: auto;
    }
`;
const LogosWrap = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 50px;
    @media screen and (max-width: 1200px) {
        margin-bottom: 40px;
    }
    @media screen and (max-width: 600px) {
        padding: 0 20px;
        max-width: 400px;
        margin: 0 auto 20px;
    }
`;
export const Logo = styled.a`
    display: block;
    text-decoration: none;
    height: 50px;
    padding: 0 25px;
    text-align: center;
    margin-bottom: 32px;
    img {
        height: auto;
        max-height: 50px;
        max-width: 200px;
        transition: 0.2s ease;
    }
    &:hover {
        img {
            transform: translateY(-10px);
        }
    }
    @media screen and (max-width: 1400px) {
        padding: 0 20px;
        height: 40px;
        img {
            max-height: 40px;
        }
    }
    @media screen and (max-width: 1200px) {
        padding: 20px;
        height: 36px;
        margin-bottom: 16px;
        /* width: calc(33.3% - 40px); */
        img {
            max-height: 36px;
        }
    }
    @media screen and (max-width: 600px) {
        height: auto;
        padding: 10px 5px;
        width: calc(50% - 10px);
        margin-bottom: 32px;
        img {
            height: auto;
            max-width: 130px;
        }
        &:hover {
            img {
                transform: none;
            }
        }
    }
`;

const DescriptionBottom = styled(Description)`
    margin-bottom: 0;
`;

const QuoteWrap = styled.div`
    position: relative;
    margin-bottom: 120px;
    @media screen and (max-width: 800px) {
        max-width: 500px;
        margin: 0 auto 50px;
    }
`;
const Quote = styled.div`
    background: #ffffff;
    box-shadow: 12px 36px 40px rgba(0, 0, 0, 0.06);
    border-radius: 20px;
    padding: 20px 35px 20px;
    margin: 0 0 40px 25px;
    position: relative;
    &:before {
        content: '“';
        display: block;
        position: absolute;
        top: -40px;
        left: -30px;
        font-family: Georgia, 'Times New Roman', Times, serif;
        font-size: 150px;
        color: #000;
    }
    @media screen and (max-width: 800px) {
        margin-top: 10px;
        padding: 20px 15px 10px;
        margin: 10px 0 20px 0;
        &:before {
            font-size: 100px;
            left: 0;
            top: -33px;
        }
    }
`;
const QuoteText = styled.p`
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 15px;
    max-width: 430px;
    @media screen and (max-width: 800px) {
        font-size: 12px;
        line-height: 16px;
        max-width: 80%;
    }
`;
const QuoteCaption = styled.div`
    width: 300px;
    @media screen and (max-width: 800px) {
        width: 60%;
        p {
            font-size: 10px;
        }
    }
`;
const QuoteName = styled.h4`
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 10px;
    @media screen and (max-width: 800px) {
        font-size: 18px;
    }
`;
const QuoteImg = styled.div`
    position: absolute;
    top: -100px;
    right: -30px;
    img {
        max-height: 450px;
    }
    @media screen and (max-width: 800px) {
        top: -15%;
        right: -80px;
        img {
            max-width: 220px;
        }
    }
`;

const partnersLogo = [
    {
        name: dms,
        link: 'https://disrupt.moscow/',
    },
    {
        name: grape,
        link: 'http://grape.ru/',
    },
    {
        name: hungry,
        link: 'https://hungryboys.ru/',
    },
    {
        name: possible,
        link: 'https://www.possiblegroup.ru/',
    },
];

export const Partners = () => (
    <Wrap id="partners">
        <Container>
            <Title>
                <TitleBlock>Наши партнеры</TitleBlock>
            </Title>
            <Description>
                Метод КЭСПА отлично подходит для всех, кто работает в рекламной
                индустрии. Нашими многолетними партнерами являются агентства
                GRAPE, HUNGRY BOYS и POSSIBLE MOSCOW, уже десять лет мы помогаем
                проводить международную конференцию Digital Marketing
                Conference. Являемся партнером Disrupt Marketing School. Вы
                можете увидеть результат наших работ среди{' '}
                <a
                    href="https://www.possiblegroup.ru/category/works"
                    target="_blank"
                >
                    портфолио агентств
                </a>
                .
            </Description>
            <QuoteWrap>
                <Quote>
                    <QuoteText>
                        Уже восемь лет я учу английский. Начинал на полном нуле,
                        полном незнании. Я не делал домашки, не зубрил правила.
                        Я просто учился с преподавателем на уроках с помощью
                        метода КЭСПА. Через год я начал говорить. Сейчас мне
                        достаточно одного урока в неделю, чтобы поддерживать
                        уровень и углублять знания.
                    </QuoteText>
                </Quote>
                <QuoteCaption>
                    <QuoteName>Владилен Ситников</QuoteName>
                    <p>Креативный директор агентства POSSIBLE</p>
                </QuoteCaption>
                <QuoteImg>
                    <img src={vlad} alt="Владилен Ситников" />
                </QuoteImg>
            </QuoteWrap>
            <LogosWrap>
                {partnersLogo.map(({ name, link }) => {
                    return (
                        <Logo key={name} href={link}>
                            <img src={name} alt="" />
                        </Logo>
                    );
                })}
            </LogosWrap>
            <DescriptionBottom>
                Интересно сотрудничество?{' '}
                <a href="mailto:mail@kespa.ru">Напишите нам!</a>
            </DescriptionBottom>
        </Container>
    </Wrap>
);
